import React from 'react';
import './DailyRiddleHint.css';

const DailyRiddleHint = ({ text = '', isCollapsed = false, onToggleCollapse = null }) => {
  const normalizedText = String(text || '').trim();
  if (!normalizedText) return null;

  return (
    <section
      className={`daily-riddle-hint ${isCollapsed ? 'daily-riddle-hint--collapsed' : ''}`.trim()}
      aria-label="Daily riddle hint"
    >
      <div className="daily-riddle-hint__header">
        <div className="daily-riddle-hint__label">Riddle Hint</div>
        {typeof onToggleCollapse === 'function' ? (
          <button
            type="button"
            className="daily-riddle-hint__toggle"
            onClick={onToggleCollapse}
            aria-label={isCollapsed ? 'Expand riddle hint' : 'Collapse riddle hint'}
            title={isCollapsed ? 'Expand riddle hint' : 'Collapse riddle hint'}
          >
            {isCollapsed ? '+' : '-'}
          </button>
        ) : null}
      </div>

      {!isCollapsed ? <p className="daily-riddle-hint__text">{normalizedText}</p> : null}
    </section>
  );
};

export default DailyRiddleHint;
